// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__b8V8-","link":"Footer_link__e5-Fl"};